module.exports = __webpack_public_path__ + "static/media/matilde-hat-greece-hello.08dff0fa.png";